export const INIT_LOGIN_STATUS = 'INIT_LOGIN_STATUS';
export const UPDATA_LOGIN_STATUS = 'UPDATA_LOGIN_STATUS';
export const UPDATA_BINDPHONE_VISIT = 'UPDATA_BINDPHONE_VISIT';
